{
  "title": "検索",
  "input_label": "商品・注文・お客様・委託者・画面を検索",
  "placeholder": "カード名、鑑定番号、商品コード、注文番号、お客様…",
  "searching": "検索中…",
  "close": "検索を閉じる",
  "results": "検索結果",
  "source_error": "ここは検索できませんでした — もう一度お試しください",
  "nothing": "「{{term}}」は見つかりませんでした",
  "nothing_hint": "つづりを確認するか、カードの鑑定番号・商品コードをスキャンしてください。",
  "empty_hint": "カード名、鑑定番号、注文番号を入力するか、バーコードをスキャンしてください。",
  "keys_hint": "↑ ↓ で移動 · Enter で開く · Esc で閉じる · ? でショートカット一覧",
  "opens_new_tab": "新しいタブで開きます",
  "actions": {
    "add_card": "カードを登録",
    "to_ship": "発送待ちの注文",
    "open_pos": "レジを開く",
    "edit_home": "トップページを編集",
    "edit_menus": "サイトのメニューを編集",
    "translate_missing": "未翻訳の文章を翻訳",
    "translate_missing_count_other": "未翻訳の文章を翻訳（{{count}}）"
  },
  "groups": {
    "lookup": "完全一致",
    "actions": "操作",
    "products": "商品",
    "orders": "注文",
    "customers": "お客様",
    "consignors": "委託者",
    "pages": "管理画面のページ",
    "recent_opened": "最近開いたもの",
    "recent_queries": "最近の検索"
  },
  "shortcuts": {
    "title": "キーボードショートカット",
    "open_search": "検索",
    "new_product": "カードを登録（商品ページで）",
    "go_orders": "注文へ移動",
    "go_products": "商品へ移動",
    "show_shortcuts": "この一覧を表示",
    "note": "入力欄に入力中や、日本語入力で変換中はショートカットは動きません。"
  }
}
